import ServiceSchema from '../schemas/ServiceSchema'

export default function ServiceVo(initData = {}) {
  return ServiceSchema.validateSync(initData)
}
